import awarenessImg from '../../../assets/awareness.png';
import fosterCareImg from '../../../assets/foster-care.png';
import legislationImg from '../../../assets/legislation.png';
import newLifeImg from '../../../assets/new-life.png';
import safeHouseImg from '../../../assets/safe-house.png';

export const activityNodes = [
  {
    ID: 17,
    type: 'pill',
    roles: [1, 2],
    label: 'Grooming',
    align: 'center',
    d: 'M322.364 293.941C319.24 290.817 319.24 285.752 322.364 282.627L338.627 266.364C341.752 263.24 346.817 263.24 349.941 266.364C353.065 269.488 353.065 274.553 349.941 277.678L333.678 293.941C330.553 297.065 325.488 297.065 322.364 293.941Z',
    to: '339.364 276.941',
    labelX: 262,
    labelY: 265,
  },
  {
    ID: 42,
    type: 'pill',
    roles: [1, 3],
    label: 'Rape',
    align: 'center',
    d: 'M400.5 577C400.5 572.582 404.082 569 408.5 569H431.5C435.918 569 439.5 572.582 439.5 577C439.5 581.418 435.918 585 431.5 585H408.5C404.082 585 400.5 581.418 400.5 577Z',
    to: '417.5 577',
    labelX: 420,
    labelY: 560,
  },
  {
    ID: 44,
    type: 'pill',
    roles: [1, 2],
    label: 'Rescue',
    align: 'center',
    d: 'M433.941 703.365C437.065 706.489 437.065 711.554 433.941 714.678L417.677 730.942C414.553 734.066 409.488 734.066 406.364 730.942C403.239 727.818 403.239 722.752 406.364 719.628L422.627 703.365C425.751 700.24 430.817 700.24 433.941 703.365Z',
    to: '425 711',
    labelX: 435,
    labelY: 735,
  },
  {
    ID: 54,
    type: 'pill',
    roles: [1, 2],
    label: 'Trauma',
    align: 'center',
    d: 'M617.486 387.364C620.61 384.24 625.675 384.24 628.799 387.364L645.063 403.627C648.187 406.752 648.187 411.817 645.063 414.941C641.939 418.065 636.873 418.065 633.749 414.941L617.486 398.678C614.362 395.553 614.362 390.488 617.486 387.364Z',
    to: '634 404',
    labelX: 640,
    labelY: 384,
  },
  {
    ID: 50,
    type: 'pill',
    roles: [1, 4],
    label: 'System Involvement',
    align: 'center',
    d: 'M702.486 211.364C705.61 208.24 710.675 208.24 713.799 211.364L730.063 227.627C733.187 230.752 733.187 235.817 730.063 238.941C726.939 242.065 721.873 242.065 718.749 238.941L702.486 222.678C699.362 219.553 699.362 214.488 702.486 211.364Z',
    to: '719.468 228.364',
    labelX: 725,
    labelY: 208,
  },
  {
    ID: 22,
    type: 'pill',
    roles: [1, 4],
    label: 'Identification',
    align: 'center',
    d: 'M917.5 577.154C917.5 572.736 921.082 569.154 925.5 569.154H948.5C952.918 569.154 956.5 572.736 956.5 577.154C956.5 581.573 952.918 585.154 948.5 585.154H925.5C921.082 585.154 917.5 581.573 917.5 577.154Z',
    to: '934.5 577',
    labelX: 950,
    labelY: 604,
  },
  {
    ID: 29,
    type: 'pill',
    roles: [1, 4],
    label: 'Legal Help',
    align: 'center',
    d: 'M1515.65 512.152C1515.65 507.734 1519.23 504.152 1523.65 504.152H1546.65C1551.07 504.152 1554.65 507.734 1554.65 512.152C1554.65 516.571 1551.07 520.152 1546.65 520.152H1523.65C1519.23 520.152 1515.65 516.571 1515.65 512.152Z',
    to: '1533.64 512.152',
    labelX: 1440,
    labelY: 490,
  },
  {
    ID: 52,
    type: 'pill',
    roles: [1, 6],
    label: 'Therapy',
    align: 'center',
    d: 'M1142.36 325.364C1145.49 322.24 1150.55 322.24 1153.68 325.364L1169.94 341.627C1173.07 344.752 1173.07 349.817 1169.94 352.941C1166.82 356.065 1161.75 356.065 1158.63 352.941L1142.36 336.678C1139.24 333.553 1139.24 328.488 1142.36 325.364Z',
    to: '1155.36 338.364',
    labelX: 1165,
    labelY: 325,
  },
  {
    ID: 25,
    type: 'pill',
    roles: [3, 4],
    label: 'Intercept',
    align: 'center',
    d: 'M975.5 704.5C975.5 700.082 979.082 696.5 983.5 696.5H1006.5C1010.92 696.5 1014.5 700.082 1014.5 704.5C1014.5 708.918 1010.92 712.5 1006.5 712.5H983.5C979.082 712.5 975.5 708.918 975.5 704.5Z',
    to: '992.5 704.5',
    labelX: 1000,
    labelY: 730,
  },
  {
    ID: 44,
    type: 'pill',
    roles: [3, 6],
    label: 'Rescue',
    align: 'center',
    d: 'M899.5 780.5C899.5 776.082 903.082 772.5 907.5 772.5H930.5C934.918 772.5 938.5 776.082 938.5 780.5C938.5 784.918 934.918 788.5 930.5 788.5H907.5C903.082 788.5 899.5 784.918 899.5 780.5Z',
    to: '915.5 780.5',
    labelX: 925,
    labelY: 810,
  },
  {
    ID: 5,
    type: 'pill',
    roles: [2, 3, 4],
    label: 'Arrest',
    align: 'center',
    d: 'M1478.36 539.364C1481.49 536.24 1486.55 536.24 1489.68 539.364L1505.94 555.627C1509.07 558.752 1509.07 563.817 1505.94 566.941C1502.82 570.065 1497.75 570.065 1494.63 566.941L1478.36 550.678C1475.24 547.553 1475.24 542.488 1478.36 539.364Z',
    to: '1488.36 555.364',
    labelX: 1518,
    labelY: 563,
  },
  {
    ID: 14,
    type: 'pill',
    roles: [5, 6],
    label: 'Education',
    align: 'center',
    d: 'M1229.21 438.288C1226.09 435.164 1226.09 430.098 1229.21 426.974L1245.48 410.711C1248.6 407.586 1253.66 407.586 1256.79 410.711C1259.91 413.835 1259.91 418.9 1256.79 422.024L1240.53 438.288C1237.4 441.412 1232.34 441.412 1229.21 438.288Z',
    to: '1237.21 426.288',
    labelX: 1260,
    labelY: 445,
  },

  // IMAGE NODES
  {
    ID: 12,
    type: 'image',
    roles: [2, 3, 4, 7],
    label: (
      <span>
        Draft
        <br />
        Legislation
      </span>
    ),
    align: 'center',
    cx: 1343.5,
    cy: 704,
    r: 24,
    href: legislationImg,
    labelX: 1305.5,
    labelY: 733,
    labelWidth: 75,
    labelHeight: 35,
  },
  {
    ID: 16,
    type: 'image',
    roles: [1],
    label: 'Foster Care',
    align: 'center',
    cx: 591.5,
    cy: 225,
    r: 24,
    href: fosterCareImg,
    labelX: 615.5,
    labelY: 244,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 6,
    type: 'image',
    roles: [1, 5, 6],
    label: 'Awareness',
    align: 'center',
    cx: 899.5,
    cy: 225,
    r: 24,
    href: awarenessImg,
    labelX: 924.5,
    labelY: 244,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 46,
    type: 'image',
    roles: [1, 6],
    label: 'Safe Houses',
    align: 'center',
    cx: 815,
    cy: 577.5,
    r: 24,
    href: safeHouseImg,
    labelX: 825.5,
    labelY: 605,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 38,
    type: 'image',
    roles: [1],
    label: 'New Life',
    align: 'center',
    cx: 1429.5,
    cy: 339,
    r: 24,
    href: newLifeImg,
    labelX: 1340.5,
    labelY: 301,
    labelWidth: 80,
    labelHeight: 20,
  },

  // DOT ACTIVITIES
  {
    ID: 3,
    type: 'dot',
    roles: [1],
    label: 'Adverse Childhood Experiences',
    align: 'right',
    cx: 155.5,
    cy: 158.5,
    labelX: 40,
    labelY: 165,
    labelWidth: 100,
    labelHeight: 60,
  },
  {
    ID: 11,
    type: 'dot',
    roles: [1],
    label: 'Divorce',
    align: 'left',
    cx: 477.5,
    cy: 111.5,
    labelX: 420,
    labelY: 124,
    labelWidth: 60,
    labelHeight: 20,
  },
  {
    ID: 7,
    type: 'dot',
    roles: [1],
    label: 'Child Welfare',
    align: 'left',
    cx: 315.5,
    cy: 111.5,
    labelX: 279,
    labelY: 79,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 45,
    type: 'dot',
    roles: [1],
    label: 'Runaway',
    align: 'left',
    cx: 213.8,
    cy: 279.5,
    labelX: 184,
    labelY: 291,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 28,
    type: 'dot',
    roles: [1],
    label: 'Juvenile Detention',
    align: 'left',
    cx: 431.5,
    cy: 280.5,
    labelX: 350,
    labelY: 290,
    labelWidth: 70,
    labelHeight: 40,
  },
  {
    ID: 47,
    type: 'dot',
    roles: [1],
    label: 'Sexual Assault',
    align: 'left',
    cx: 551.5,
    cy: 399.5,
    labelX: 502,
    labelY: 411,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 19,
    type: 'dot',
    roles: [1],
    label: 'Hospital Visits',
    align: 'left',
    cx: 699.5,
    cy: 576.5,
    labelX: 654,
    labelY: 591,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 1,
    type: 'dot',
    roles: [1],
    label: 'Abortion',
    align: 'left',
    cx: 419.5,
    cy: 646.5,
    labelX: 354,
    labelY: 652,
    labelWidth: 60,
    labelHeight: 20,
  },
  {
    ID: 33,
    type: 'dot',
    roles: [1],
    label: 'Mental Health Challenges',
    align: 'center',
    cx: 756.5,
    cy: 457.5,
    labelX: 705,
    labelY: 475,
    labelWidth: 100,
    labelHeight: 40,
    labelBackground: '#0F172AAA',
  },
  {
    ID: 8,
    type: 'dot',
    roles: [1],
    label: 'Clinic Visits',
    align: 'left',
    cx: 673.5,
    cy: 717.5,
    labelX: 634,
    labelY: 731,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 39,
    type: 'dot',
    roles: [1],
    label: 'Optimism',
    align: 'left',
    cx: 1534.5,
    cy: 437.5,
    labelX: 1534,
    labelY: 403,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 37,
    type: 'dot',
    roles: [1],
    label: 'New Job',
    align: 'left',
    cx: 1278.5,
    cy: 338.5,
    labelX: 1249,
    labelY: 306,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 43,
    type: 'dot',
    roles: [1],
    label: 'Recovery',
    align: 'left',
    cx: 1102.5,
    cy: 512.5,
    labelX: 1063,
    labelY: 479,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 41,
    type: 'dot',
    roles: [1, 2],
    label: 'Pregnancy',
    align: 'left',
    cx: 559.5,
    cy: 576.5,
    labelX: 524,
    labelY: 546,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 49,
    type: 'dot',
    roles: [2],
    label: 'Substance Abuse',
    align: 'left',
    cx: 290.5,
    cy: 327.5,
    labelX: 234,
    labelY: 341,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 20,
    type: 'dot',
    roles: [2],
    label: 'Hotel Room Visits',
    align: 'right',
    cx: 227.5,
    cy: 757.5,
    labelX: 110,
    labelY: 740,
    labelWidth: 100,
    labelHeight: 40,
  },
  {
    ID: 18,
    type: 'dot',
    roles: [2],
    label: 'Homeless Shelter',
    align: 'left',
    cx: 461.5,
    cy: 231.5,
    labelX: 412,
    labelY: 185,
    labelWidth: 100,
    labelHeight: 40,
  },
  {
    ID: 2,
    type: 'dot',
    roles: [2],
    label: 'Abuse',
    align: 'left',
    cx: 696.5,
    cy: 469.5,
    labelX: 634,
    labelY: 459,
    labelWidth: 60,
    labelHeight: 20,
  },
  {
    ID: 48,
    type: 'dot',
    roles: [2],
    label: 'Slavery',
    align: 'left',
    cx: 227.5,
    cy: 657.5,
    labelX: 164,
    labelY: 647,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 26,
    type: 'dot',
    roles: [2],
    label: 'Investigation',
    align: 'left',
    cx: 1491.5,
    cy: 615.5,
    labelX: 1509,
    labelY: 606,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 15,
    type: 'dot',
    roles: [2],
    label: 'Evidence Collection',
    align: 'left',
    cx: 1402.5,
    cy: 704.5,
    labelX: 1420,
    labelY: 704,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 51,
    type: 'dot',
    roles: [2],
    label: 'Testifying',
    align: 'left',
    cx: 1263.5,
    cy: 780.5,
    labelX: 1264,
    labelY: 796,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 24,
    type: 'dot',
    roles: [2],
    label: 'Influence',
    align: 'left',
    cx: 507.5,
    cy: 277.5,
    labelX: 524,
    labelY: 268,
    labelWidth: 100,
    labelHeight: 20,
  },
  {
    ID: 40,
    type: 'dot',
    roles: [2, 3],
    label: 'Payment',
    align: 'left',
    cx: 353.5,
    cy: 781.5,
    labelX: 360,
    labelY: 800,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 53,
    type: 'dot',
    roles: [2, 3],
    label: 'Trafficking',
    align: 'left',
    cx: 365.5,
    cy: 523.8,
    labelX: 361,
    labelY: 489,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 55,
    type: 'dot',
    roles: [3],
    label: 'Demand Interruption',
    align: 'left',
    cx: 287.5,
    cy: 711.5,
    labelX: 315,
    labelY: 695,
    labelWidth: 80,
    labelHeight: 40,
  },
  {
    ID: 10,
    type: 'dot',
    roles: [3],
    label: 'CSAM / Child Porn',
    align: 'center',
    cx: 500,
    cy: 781.5,
    labelX: 465,
    labelY: 800,
    labelWidth: 70,
    labelHeight: 40,
  },
  {
    ID: 14,
    type: 'dot',
    roles: [3, 5, 6],
    label: 'Education',
    align: 'center',
    cx: 640,
    cy: 781.5,
    labelX: 605,
    labelY: 800,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 56,
    type: 'dot',
    roles: [3],
    label: 'Data',
    align: 'center',
    cx: 775,
    cy: 781.5,
    labelX: 740,
    labelY: 800,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 35,
    type: 'dot',
    roles: [3],
    label: 'Molestation',
    align: 'left',
    cx: 127.5,
    cy: 463.5,
    labelX: 88,
    labelY: 431,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 51,
    type: 'dot',
    roles: [3],
    label: 'Testifying',
    align: 'left',
    cx: 1282.5,
    cy: 645.5,
    labelX: 1211,
    labelY: 613,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 26,
    type: 'dot',
    roles: [3],
    label: 'Investigation',
    align: 'left',
    cx: 1376.5,
    cy: 552.5,
    labelX: 1334,
    labelY: 523,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 26,
    type: 'dot',
    roles: [4, 6],
    label: 'Investigation',
    align: 'left',
    cx: 772.5,
    cy: 281.5,
    labelX: 694,
    labelY: 294,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 23,
    type: 'dot',
    roles: [4],
    label: 'Incarceration',
    align: 'left',
    cx: 1420.5,
    cy: 624.5,
    labelX: 1319,
    labelY: 613,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 31,
    type: 'dot',
    roles: [4],
    label: 'Locate',
    align: 'left',
    cx: 998.5,
    cy: 455.5,
    labelX: 1014,
    labelY: 446,
    labelWidth: 50,
    labelHeight: 20,
  },
  {
    ID: 5,
    type: 'dot',
    roles: [4],
    label: 'Arrest',
    align: 'left',
    cx: 998.5,
    cy: 515.5,
    labelX: 1014,
    labelY: 506,
    labelWidth: 50,
    labelHeight: 20,
  },
  {
    ID: 9,
    type: 'dot',
    roles: [4, 5],
    label: 'Continued Care',
    align: 'left',
    cx: 904.5,
    cy: 357.5,
    labelX: 917,
    labelY: 328,
    labelWidth: 110,
    labelHeight: 20,
  },
  {
    ID: 23,
    type: 'dot',
    roles: [4],
    label: 'Incarceration',
    align: 'left',
    cx: 936.5,
    cy: 642.5,
    labelX: 849,
    labelY: 656,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 14,
    type: 'dot',
    roles: [5],
    label: 'Education',
    align: 'left',
    cx: 771.5,
    cy: 165.5,
    labelX: 684,
    labelY: 155,
    labelWidth: 80,
    labelHeight: 20,
  },
  {
    ID: 13,
    type: 'dot',
    roles: [5],
    label: 'Economic Stability',
    align: 'center',
    cx: 845.5,
    cy: 167.5,
    labelX: 840,
    labelY: 140,
    labelWidth: 100,
    labelHeight: 40,
  },
  {
    ID: 27,
    type: 'dot',
    roles: [5],
    label: 'Job Training',
    align: 'left',
    cx: 1108.5,
    cy: 424.5,
    labelX: 1069,
    labelY: 436,
    labelWidth: 90,
    labelHeight: 20,
  },
  {
    ID: 32,
    type: 'dot',
    roles: [5, 7],
    label: 'Media Engagement',
    align: 'left',
    cx: 1421.5,
    cy: 786.5,
    labelX: 1424,
    labelY: 758,
    labelWidth: 140,
    labelHeight: 20,
  },
  {
    ID: 21,
    type: 'dot',
    roles: [6],
    label: 'Housing',
    align: 'left',
    cx: 813.5,
    cy: 442.5,
    labelX: 829,
    labelY: 433,
    labelWidth: 60,
    labelHeight: 20,
  },
  {
    ID: 4,
    type: 'dot',
    roles: [6],
    label: 'Advocacy',
    align: 'left',
    cx: 813.5,
    cy: 673.5,
    labelX: 754,
    labelY: 686,
    labelWidth: 70,
    labelHeight: 20,
  },
  {
    ID: 21,
    type: 'dot',
    roles: [6],
    label: 'Housing',
    align: 'left',
    cx: 849.5,
    cy: 281.5,
    labelX: 824,
    labelY: 294,
    labelWidth: 60,
    labelHeight: 20,
  },
  {
    ID: 36,
    type: 'dot',
    roles: [6],
    label: 'Move to New Location',
    align: 'right',
    cx: 658.5,
    cy: 283.5,
    labelX: 570,
    labelY: 295,
    labelWidth: 90,
    labelHeight: 40,
  },
  {
    ID: 34,
    type: 'dot',
    roles: [6],
    label: 'Mentorship',
    align: 'left',
    cx: 1155.5,
    cy: 162.5,
    labelX: 1171,
    labelY: 153,
    labelWidth: 80,
    labelHeight: 20,
  },
];
